<script setup>
import { ref, onMounted } from "vue";
import { useModals } from "@/composables/useModals";
import { useScrollStore } from "@/stores/storeScroll";
import { useSettingsStore } from "@/stores/storeSettings";
import { rulesUrl } from "@/utils/provider";
import { sendMetrik } from "@/utils/metrika";

const { openModal } = useModals();
const storeScroll = useScrollStore();
const storeSettings = useSettingsStore();

const faqActive = ref({});
const dataFaq = ref([]);
const smoother = ref(null);



const formatAnswer = (text) => {
	if (!text) return "";
	const escaped = text.replace(/(?:\r\n|\r|\n)/g, "<br>").replace("Правил по ссылке", `<a href="${rulesUrl}" target="_blank" rel="noopener noreferrer">ссылке</a>`);
	return escaped;
};

const openFaqItem = (index) => {
	const newActiveState = {};
	for (let i = 0; i < dataFaq.value.length; i++) {
		newActiveState[i] = i === index ? !faqActive.value[index] : false;
	}
	faqActive.value = newActiveState;
};

onMounted(async () => {
	dataFaq.value = await storeSettings.getFaq();
});
</script>
<template>
	<section class="faq section" id="faq">
		<div class="container">
			<h2 class="faq__title title">Вопросы-ответы</h2>
			<div :class="['faq__container', { '--telegram': storeSettings.isTelegramPage }]">
				<div class="decor">
					<div class="decor__item"></div>
					<ul v-if="dataFaq" class="faq__list list-scrollbar">
						<li :class="['faq__item', { active: faqActive[index] }]" data-accordion-parent v-for="(faq, index) in dataFaq" :key="index" @click="openFaqItem(index)">
							<div class="faq__question">
								{{ faq.question }}
								<div class="faq__btn">
									<svg width="32" height="32"><use href="#faq_check"></use></svg>
								</div>
							</div>
							<div class="faq__answer" data-accordion-hidden>								
								<div style="min-height: 0" v-html="formatAnswer(faq.answer)"></div>
							</div>
						</li>
					</ul>
				</div>
				<div v-if="!storeSettings.isTelegramPage" class="faq__block" :style="{ top: storeScroll.header?.offsetHeight + 20 + 'px' }">
					<h3 class="faq__block-title title3">Остались вопросы?</h3>
					<p class="faq__block-text">Заполните форму, и мы обязательно Вам ответим!</p>
					<button class="faq__feedback-btn btn" @click="openModal('feedback'), sendMetrik('reachGoal', 'click_ask_question')">Задать вопрос</button>
				</div>
			</div>
		</div>
	</section>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
@use "@/assets/scss/blocks/accordion-grid.scss";
.faq {
	position: relative;
	background-image: url("@/assets/img/faq/faq_bg.webp");
	background-repeat: no-repeat;
	background-position: right top; /* x y*/
	background-size: auto; /* w h*/
	padding: 7rem 0;
	@media (max-width: vars.$l) {
		background-position: right 100%;
    	// background-size: contain;
	}
	@media (max-width: vars.$m) {
		background-size: contain;
	}
	@media (max-width: vars.$x480) {
		padding: 3rem 0 6rem;
		background-size: 54rem 53rem;
	}
}
.faq__title {
	margin-bottom: 6rem;
	@media (max-width: vars.$x480) {
		margin-bottom: 1.6rem;
	}
}
.faq__container {
	position: relative;
	display: grid;
	grid-template-columns: 1fr 50rem;
	align-items: start;
	gap: 7rem;
	z-index: 1;
	&.--telegram {
		grid-template-columns: 1fr;
		
	}
	@media (max-width: vars.$mn) {
		grid-template-columns: 1fr;
	}
	@media (max-width: vars.$xx) {
		grid-template-columns: 1fr;
		gap: 3rem;
	}
}
.decor {
	position: relative;
}

.decor__item {
	// position: absolute;
	// width: 6px;
	// height: 100%;
	// top: 0;
	// right: 0;
	// z-index: 1;
	// &::before {
	// 	position: absolute;
	// 	content: "";
	// 	width: 100%;
	// 	height: 30px;
	// 	background-image: url("@/assets/img/icons/decor_list.svg");
	// 	background-repeat: no-repeat;
	// 	background-position: 0px 0px; /* x y*/
	// 	background-size: auto; /* w h*/
	// 	left: 0;
	// 	top: 0;
	// }
	// &::after {
	// 	position: absolute;
	// 	content: "";
	// 	width: 100%;
	// 	height: 30px;
	// 	background-image: url("@/assets/img/icons/decor_list.svg");
	// 	background-repeat: no-repeat;
	// 	background-position: 0px 0px; /* x y*/
	// 	background-size: auto; /* w h*/
	// 	transform: rotate(180deg);
	// 	left: 0;
	// 	bottom: 0;
	// }
}
.faq__list {
	display: grid;
	gap: 2.1rem;
	max-height: 61.5rem;
	padding-right: 2.4rem;
	@media (max-width: vars.$m) {
		max-height: 54rem;
	}
	@media (max-width: vars.$x480) {
		margin-right: 0px;
		padding-right: 15px;
		max-height: 34rem;
		gap: .8rem;
	}
	@media (max-width: vars.$x393) {
		        max-height: 40rem;
	}
}
.faq__item {
	padding: 4.3rem 4rem 4rem;
	transition: var(--transition) ease-in;
	border: 1px solid var(--border-accent-2-3);
	border-radius: 4rem;
	@extend .base-bg;
	@media (max-width: vars.$t) {
	}
	@media (max-width: vars.$x480) {
		padding: 24px 16px;
		border-radius: 1.6rem;
	}
	&.active {
		border: 1px solid var(--border-accent-2-1);
		.faq__btn {
			transform: rotate(180deg);
		}
		.faq__answer {
			padding-top: 1.4rem;
			@media (max-width: vars.$xx) {
				padding-top: 1rem;
			}
		}
	}
}
.faq__question {
	width: 100%;
	display: flex;
	align-items: start;
	justify-content: space-between;
	font-weight: 700;
	gap: 2.4rem;
	font-size: 2.4rem;
	line-height: 140%;
	color: var(--text-accent-2-100);
	cursor: pointer;
	@media (max-width: vars.$x480) {
		font-size: 1.6rem;
		gap: 1.5rem;
	}
	@media (hover: hover) {
		&:hover {
			.faq__btn {
			}
		}
	}
}
.faq__btn {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 3.2rem;
	height: 3.2rem;
	transition: var(--transition) ease-in;
	@media (max-width: vars.$x480) {
	}
	svg {
		width: 100%;
		height: 100%;
	}
}
.faq__answer {
	font-weight: 400;
	font-size: 2rem;
	line-height: 160%;
	color: var(--text-inverse-100);
	@media (max-width: vars.$x480) {
		font-size: 1.6rem;
	}
	a {
		color: inherit;
		@media (hover: hover) {
			&:hover {
				text-decoration: underline;
			}
		}
	}

	span {
		font-family: var(--third-family);
	}
	:deep(th) {
		@media (max-width: vars.$x480) {
			font-size: 1.4rem;
			line-height: 120%
		}
	}
	:deep(td) {
		@media (max-width: vars.$x480) {
			font-size: 1.2rem;
		}
	}
	:deep(td:nth-child(2)) {
		text-align: center;
	}
}

.faq__block {
	position: relative;
	display: grid;
	gap: 1.5rem;
	position: sticky;
	z-index: 1;
	border: 1px solid var(--border-accent-2-3);
	border-radius: 4rem;
	backdrop-filter: blur(15.399999618530273px);
	box-shadow: inset 0 13px 35px 0 rgba(255, 255, 255, 0.14);
	background: linear-gradient(143deg, #165230 0%, #0b2e1b 100%);
	padding: 3.7rem 3.7rem;
	@media (max-width: vars.$x480) {
		padding: 2.5rem;
		border-radius: 2.4rem;
		gap: 1.7rem;
	}

	&::before {
		position: absolute;
		content: "";
		background-image: url("@/assets/img/faq/faq_shape.webp");
		background-repeat: no-repeat;
		background-position: 0px 0px; /* x y*/
		background-size: contain; /* w h*/
		width: 22.7rem;
		height: 25.6rem;
		top: -62%;
		right: -15%;
		@media (max-width: vars.$mn) {
			width: 7.2rem;
			height: 8.2rem;
			top: 75%;
			right: -4%;
			z-index: 2;
		}
	}
}
.faq__block-title {
}
.faq__block-text {
	font-weight: 500;
	font-size: 2rem;
	line-height: 120%;
	color: var(--text-inverse-100);
	@media (max-width: vars.$x480) {
		font-size: 1.6rem;
	}
}
.faq__feedback-btn {
	width: 100%;
	@media (max-width: vars.$x480) {
	}
}
</style>
